import React from 'react';
import { View,ImageBackground, Image, TouchableOpacity, Dimensions} from 'react-native';
import style from './style';
import api from '../config/api_urls';
import Menu from '../menu';
import AsyncStorage from '@react-native-community/async-storage';

//ordre 4
 class MenuPosicionament extends React.Component{

    constructor(props) {
        super(props);
        this.state = props.route.params;
        this.state['navigation'] = this.props.navigation;
        this.state["current_page"] = this.state.projecte.pagines.find((page) => page.id == 26);
        this.pages = (typeof this.state.projecte !== 'undefined' && typeof this.state.projecte.pagines !== 'undefined') ? this.state.projecte.pagines : [];
        this.state["selectedPage"] = {}
    }

    loadPagina(tipus, props) {
      this.state["selectedPage"] = props;
      if(tipus == "Tipus1") {
        AsyncStorage.setItem('anarCredits',true);
        this.props.navigation.navigate('Joc1', this.state)
      }
      else if (tipus == "Tipus2") {
         AsyncStorage.setItem('anarCredits',false);
        this.props.navigation.navigate('Joc2', this.state)
      }
    }
    changeScreenOrientation = async () => {
        await ScreenOrientation.lockAsync(ScreenOrientation.OrientationLock.PORTRAIT);
      }

    loadPagina(tipus, props) {
        this.state["selectedPage"] = props;
        if (tipus == "Tipus1") {
            AsyncStorage.setItem('anarCredits', true);
            this.props.navigation.navigate('Joc1', this.state)
        } else if (tipus == "Tipus2") {
            AsyncStorage.setItem('anarCredits', false);
            this.props.navigation.navigate('Joc2', this.state)
        }
        else if (tipus == "360") {
            this.props.navigation.navigate('Joc3', this.state)
        }
        else if (tipus == "Tipus3") {
            AsyncStorage.setItem('anarCredits', false);
            this.props.navigation.navigate('Pagina6', this.state)
        }
        else if (tipus == "Tipus4") {
            AsyncStorage.setItem('anarCredits', false);
            this.props.navigation.navigate('Itineraris', this.state)
        }
    }

    render() {
        console.log("MenuPosicionament");
        console.log(this.state);

        return (
            <View style={{flex: 15}}>
                <ImageBackground source={{uri: api.api_url + this.state.recursos.find(e=> e.tipus_recurs == "fons_menu")["imatge_recurs"+this.state.idioma].url}} style={style.imageBackgroundHoritzontal}>             
                    <View style={{flex: 1, width: "100%",paddingTop: Dimensions.get('window').height * 0.28}}>
                        <View style={{flex: 3 , }}>
                            <TouchableOpacity style={{flex: 1}} onPress={()=>{   this.props.navigation.navigate('Intro360', this.state)  }}>
                            </TouchableOpacity>
                        </View>
                        <View style={{flex: 3 ,marginTop: Dimensions.get('window').height *0.07}}>
                        <TouchableOpacity style={{flex: 1}} onPress={()=>{ this.loadPagina("Tipus2",this.state.projecte.pagines[0]); }}>
                            </TouchableOpacity>
                        </View>
                        <View style={{flex: 4 ,marginTop: Dimensions.get('window').height *0.06}}>
                        <TouchableOpacity style={{flex: 1}} onPress={()=>{ this.loadPagina("Tipus2",this.state.projecte.pagines[2]); }}>
                            </TouchableOpacity>
                        </View>
                        <View style={{flex: 4 ,marginTop: Dimensions.get('window').height *0.06 , }}>
                            <TouchableOpacity style={{flex: 1}} onPress={()=>{ this.loadPagina("Tipus2",this.state.projecte.pagines[1]); }}>
                            </TouchableOpacity>
                        </View>
                        <View style={{flex: 3,width:'50%',alignSelf:'center'}}>
                            {/* <TouchableOpacity style={{flex: 1}} onPress={()=>{ this.loadPagina("Tipus2",this.state.projecte.pagines[2]); }}>
                            </TouchableOpacity> */}
                        </View>
                        <View
          style={{ flex: 2, bottom: 0, left: 0, right: 0, position: "fixed" }}
        >
          <Menu projecte={this.state}></Menu>
        </View>
                   </View> 
                </ImageBackground>

                {(this.state.finalitzacioItinerari && this.state.finalitzacioItinerari !== "") ? this._renderPopUp() : ""}

            </View>)
    }
}
export default MenuPosicionament;


// const items = []
// if(this.pages.length > 0) {
//   for (const [index, value] of this.pages.entries()) {
//     if(value.Tipus != "Tipus3"){
//     items.push(
//       <View style={{flex:1}}>
//         <TouchableOpacity key={index}  onPress={()=>{ this.loadPagina(value.Tipus, value); }}>
//           <View style={{width: ((Dimensions.get('screen').width /100 * 50) + (Dimensions.get('screen').width /100 * 25)), height:( Dimensions.get('screen').height/100 * 20),position:'absolute',}}>
//               <Image source={{ uri: api.api_url + value.Imatge.url}} style={{height: this.state.pop_up_height * 0.12, resizeMode: 'contain', marginTop: 1}}></Image>
//           </View>
//         </TouchableOpacity>
//       </View>
//     )
//   }
// }
// }